/* eslint-disable no-console */
import { collection, getDocs, getDoc, doc, query, where, updateDoc } from 'firebase/firestore'
import lista from './lista.json'
import { db } from '../config/firebase';
const collectionInvitados = 'invitados'
export const mensajeError = 'Ocurrió un error, intenta de nuevo más tarde';
export const mensajeOk = 'Asistencias actualizadas';


export const getData = async (codigo) => {
  let invitado = false;
  const q = query(collection(db, collectionInvitados), where('telefono', '==', parseInt(codigo)));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    invitado = doc.data()
  });
  return invitado;
}

export const getListaInvitados = async (idParent) => {
  let listaInvitados = [];
  const q = query(collection(db, collectionInvitados), where('idparent', '==', idParent));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    listaInvitados.push(doc.data())
  });
  return listaInvitados;
}

export const updateAsistencia = async (listaInvitados) => {
  try {
    await listaInvitados.forEach(async invitado => {
      const { codigo, kids, kidsconfirmados, boletosconfirmados } =
        invitado;
      const invitadoDocRef = doc(db, collectionInvitados, codigo);
      await updateDoc(invitadoDocRef, {
        'kidsconfirmados': kids > 0 ? parseInt(kidsconfirmados) || 0 : 0,
        'boletosconfirmados': parseInt(boletosconfirmados) || 0
      });
    });
    return mensajeOk
  } catch (error) {
    return mensajeError
  }
}

// export const setInvitados = async () => {
//   const batch = writeBatch(db);
//   console.log(lista)
//   lista.forEach(element => {
//     const nycRef = doc(db, "invitados", element.codigo);
//     batch.set(nycRef, element);
//   });
//   await batch.commit();
// }